import React, { useCallback, useEffect, useState } from 'react';
import { Modal as ModalSuite, Table } from 'rsuite';
import api from '../../../services/api';
import { moeda } from '../../../components/funcoes';
import {
  Container,
  ContainerInterno,
  ContainerInternoCheck,
} from '../TaxasLote/styles';
import { useAuth } from '../../../hooks/auth';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { CustomHeaderCell } from '../../../components/CustomHeaderCell';
import { CustomCell } from '../../../components/CustomCell';
import { CustomInput } from '../../../components/CustomInput';

export default function RankingVendasBairro({ modal, fecharModal }) {
  const { id_empresa } = useAuth();
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);
  const [totalSemCadastro, setTotalSemCadastro] = useState({});
  const [totalComCadastro, setTotalComCadastro] = useState({});
  const { Column } = Table;
  const { theme } = useCustomTheme();

  const filtrar = useCallback(async () => {
    setLoading(true);
    let inicial = null,
      final = null;
    if (dataInicio && dataFim) {
      inicial = dataInicio;
      final = dataFim;
    } else {
      let data = new Date();
      let primeiroDia = new Date(data.getFullYear(), data.getMonth(), 1);
      let ultimoDia = new Date(data.getFullYear(), data.getMonth() + 1, 0);
      inicial =
        primeiroDia.getFullYear() +
        '-' +
        ('00' + (primeiroDia.getMonth() + 1)).slice(-2) +
        '-' +
        ('00' + primeiroDia.getDate()).slice(-2);
      final =
        ultimoDia.getFullYear() +
        '-' +
        ('00' + (ultimoDia.getMonth() + 1)).slice(-2) +
        '-' +
        ('00' + ultimoDia.getDate()).slice(-2);
    }
    setDataInicio(inicial);
    setDataFim(final);
    await api
      .post('/pedido/estatisticasPorBairro', {
        IdEmpresa: id_empresa,
        DataInicial: dataInicio,
        DataFinal: dataFim,
      })
      .then((res) => {
        if (res.data) {
          let qtdTotalSemcadastro = res.data.SemCadastro.reduce(
            (sum, li) => sum + parseInt(li.Quantidade),
            0,
          );
          let valorTotalSemCadastro = res.data.SemCadastro.reduce(
            (sum, li) => sum + Number(li.Total),
            0,
          );
          let qtdTotalComcadastro = res.data.ComCadastro.reduce(
            (sum, li) => sum + parseInt(li.Quantidade),
            0,
          );
          let valorTotalComCadastro = res.data.ComCadastro.reduce(
            (sum, li) => sum + Number(li.Total),
            0,
          );
          setTotalSemCadastro({
            quantidade: qtdTotalSemcadastro,
            total: valorTotalSemCadastro,
          });
          setTotalComCadastro({
            quantidade: qtdTotalComcadastro,
            total: valorTotalComCadastro,
          });
          setRanking(res.data);
        }
      });
    setLoading(false);
  }, [dataFim, dataInicio]);

  useEffect(() => {
    filtrar();
  }, [filtrar]);

  return (
    <ModalSuite
      open={modal}
      onClose={fecharModal}
      backdrop={'static'}
      size={'lg'}
    >
      <ModalSuite.Header>
        <ModalSuite.Title>Ranking de vendas por Bairros</ModalSuite.Title>
      </ModalSuite.Header>

      <ModalSuite.Body>
        <Container>
          <ContainerInternoCheck>
            <ContainerInterno>
              <label
                htmlFor="dataFim"
                style={{ color: theme.colors.textSecondary }}
              >
                Data Inicial
              </label>
              <CustomInput
                type="date"
                value={dataInicio}
                onChange={setDataInicio}
              />
            </ContainerInterno>
            <ContainerInterno>
              <label
                htmlFor="dataFim"
                style={{ color: theme.colors.textSecondary }}
              >
                Data Final
              </label>
              <CustomInput type="date" value={dataFim} onChange={setDataFim} />
            </ContainerInterno>
          </ContainerInternoCheck>
        </Container>
        {loading && (
          <div className="d-flex justify-content-center">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
        {!loading && (
          <div>
            <h6
              style={{
                textAlign: 'center',
                marginTop: 10,
                color: theme.colors.text,
              }}
            >
              Pedidos sem cadastros
            </h6>
            <Table
              height={160}
              style={{
                overflowY: 'auto',
                alignItems: 'center',
                justifyContent: 'center',
                color: theme.colors.textSecondary,
              }}
              data={ranking.SemCadastro}
              locale={{
                emptyMessage: 'Nenhum pedido encontrado',
                loading: 'Carregando pedidos...',
              }}
            >
              <Column align="center" fixed>
                <CustomHeaderCell>Cod. Bairro</CustomHeaderCell>
                <CustomCell dataKey="Id" />
              </Column>

              <Column flexGrow={1}>
                <CustomHeaderCell>Bairro</CustomHeaderCell>
                <CustomCell dataKey="Bairro" />
              </Column>

              <Column flexGrow={1}>
                <CustomHeaderCell>Quantidade</CustomHeaderCell>
                <CustomCell dataKey="Quantidade" />
              </Column>

              <Column flexGrow={1}>
                <CustomHeaderCell>Total</CustomHeaderCell>

                <CustomCell>
                  {(rowData) => <text>{moeda(rowData.Total)}</text>}
                </CustomCell>
              </Column>
            </Table>
            <h6
              style={{
                textAlign: 'center',
                marginTop: 10,
                color: theme.colors.text,
              }}
            >
              Pedidos com cadastro
            </h6>
            <Table
              height={160}
              style={{
                overflowY: 'auto',
                alignItems: 'center',
                justifyContent: 'center',
                color: theme.colors.textSecondary,
              }}
              data={ranking.ComCadastro}
              locale={{
                emptyMessage: 'Nenhum pedido encontrado',
                loading: 'Carregando pedidos...',
              }}
            >
              <Column align="center" fixed>
                <CustomHeaderCell>Cod. Bairro</CustomHeaderCell>
                <CustomCell dataKey="Id" />
              </Column>

              <Column flexGrow={1}>
                <CustomHeaderCell>Bairro</CustomHeaderCell>
                <CustomCell dataKey="Bairro" />
              </Column>

              <Column flexGrow={1}>
                <CustomHeaderCell>Quantidade</CustomHeaderCell>
                <CustomCell dataKey="Quantidade" />
              </Column>

              <Column flexGrow={1}>
                <CustomHeaderCell>Total</CustomHeaderCell>

                <CustomCell>
                  {(rowData) => <text>{moeda(rowData.Total)}</text>}
                </CustomCell>
              </Column>
            </Table>
          </div>
        )}
      </ModalSuite.Body>
    </ModalSuite>
  );
}
